import { render } from "./HologramKind.vue?vue&type=template&id=f933d8d4&scoped=true"
import script from "./HologramKind.vue?vue&type=script&lang=js"
export * from "./HologramKind.vue?vue&type=script&lang=js"

import "./HologramKind.vue?vue&type=style&index=0&id=f933d8d4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f933d8d4"]])

export default __exports__